import { Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useForm } from "react-hook-form";
import React from "react";
import SignupOnboardingWrapper from "../components/SignupOnboardingWrapper";
import PrimaryButton from "../components/PrimaryButton";
import SecondaryButton from "../components/SecondaryButton";
import Input from "../components/Input";

const SIGNUP_HREF = "/onboarding/signup";
const FORGOT_PASSWORD_HREF = "/recover-password";

export default function Signup() {
  const { signInWithEmail, signInWithGoogle, errors, loading } = useAuth();

  const { register, handleSubmit } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const submit = input => {
    if (loading) return null;
    const { email, password } = input;
    signInWithEmail(email, password);
  };

  return (
    <SignupOnboardingWrapper>
      <div className="block sm:grid grid-cols-1 w-full px-4 sm:px-0">
        <div className="flex items-center justify-center">
          <div className="w-full sm:max-w-sm">
            <div>
              <h2 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
                Welcome back
              </h2>
              <p className="mt-2 text-sm/6 text-gray-500">
                Welcome back! Please enter your details.
              </p>
            </div>

            <div className="mt-6 sm:mt-10">
              <div>
                <form onSubmit={handleSubmit(submit)} className="space-y-6">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm/6 font-medium text-gray-900"
                    >
                      Email
                    </label>
                    <div className="mt-2">
                      <Input
                        name="email"
                        type="email"
                        autoComplete="email"
                        placeholder="Enter your email"
                        register={register}
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm/6 font-medium text-gray-900"
                    >
                      Password
                    </label>
                    <div className="mt-2">
                      <Input
                        name="password"
                        type="password"
                        autoComplete="current-password"
                        placeholder="Create a password"
                        register={register}
                        error={errors[0]}
                      />
                    </div>
                    <div className="mt-2 flex justify-end">
                      <Link
                        to={FORGOT_PASSWORD_HREF}
                        className="font-semibold text-primary hover:text-primary text-xs"
                      >
                        Forgot password
                      </Link>
                    </div>
                  </div>

                  <PrimaryButton loading={loading}>
                    {loading ? "Sign in..." : "Sign in"}
                  </PrimaryButton>
                </form>
              </div>

              <div className="mt-6">
                <SecondaryButton
                  onClick={signInWithGoogle}
                  type="button"
                  startIcon={
                    <svg
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      className="h-5 w-5"
                    >
                      <path
                        d="M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25527 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z"
                        fill="#EA4335"
                      />
                      <path
                        d="M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z"
                        fill="#4285F4"
                      />
                      <path
                        d="M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z"
                        fill="#FBBC05"
                      />
                      <path
                        d="M12.0004 24.0001C15.2404 24.0001 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2654 14.29L1.27539 17.385C3.25539 21.31 7.3104 24.0001 12.0004 24.0001Z"
                        fill="#34A853"
                      />
                    </svg>
                  }
                >
                  Sign in with Google
                </SecondaryButton>
              </div>

              <p className="mt-6 sm:mt-10 text-center text-sm/6 text-gray-500">
                Don't have an account?{" "}
                <Link
                  to={SIGNUP_HREF}
                  className="font-semibold text-primary hover:text-primary"
                >
                  Sign up
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </SignupOnboardingWrapper>
  );
}
